import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import GalleryGrid from "@/components/GalleryGrid";
import { Btn } from "@/components/Btn";
import { CTA } from "@/lib/brand";
import { GALLERY, galleryLd } from "@/lib/gallery";

export default function Gallery() {
  return (
    <>
      <Seo path="/gallery" title="Job Photo Gallery" description="Real junk removal job photos from Skedaddle across the Charleston tri-county area: Summerville, Goose Creek, Moncks Corner, North Charleston, Ladson, West Ashley and more." image="/gallery/01-garage-cleanout-truck-trailer.webp" jsonLd={galleryLd(GALLERY)} />
      <PageHero center eyebrow="Our work" title="Real jobs. Real junk. Gone." subtitle="Garages, sheds, curbside piles and whole house cleanouts across Summerville, Goose Creek, Moncks Corner, North Charleston, Ladson, West Ashley, Charleston and beyond. Tap any photo to see it big." />
      <section className="bg-white py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <GalleryGrid items={GALLERY} />
          <div className="mt-12 flex flex-wrap justify-center gap-3">
            <Btn to="/contact" variant="primary">{CTA.quote}</Btn>
            <Btn href="/text" variant="secondary">Text us a photo</Btn>
          </div>
        </div>
      </section>
    </>
  );
}
